import "react-responsive-carousel/lib/styles/carousel.min.css"; 

import React, { useState } from 'react'
import { PopUp } from "./Popup";


export const SeccFooter = () => {

    const [modalShow, setModalShow] = useState(false)

    return (
        <div className="footer-main">
            <div className="footer-dona">
                <div className="button-dona" onClick={() => setModalShow(true)}>
                    CONOCE LOS CASOS
                </div>
                <PopUp
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                />
                
            </div>
            <div className="footer-inferior">
                <div className="footer-inferior-izq">

                </div>
                <div className="footer-inferior-cent">
                    <a className="a-redes" href="https://www.facebook.com/amnistiamexico" target="_blank" rel="noopener noreferrer" >
                        <div className="facebook"><div className="imagen-facebook"></div></div>
                    </a>
                    <a className="a-redes" href="https://www.instagram.com/aimexico/" target="_blank" rel="noopener noreferrer">
                        <div className="instagram" rel="noopener noreferrer"><div className="imagen-instagram"></div></div>
                    </a>
                    <a className="a-redes" href="https://twitter.com/aimexico" target="_blank" rel="noopener noreferrer">
                        <div className="twitter"><div className="imagen-twitter"></div></div>
                    </a>
                    <a className="a-redes" href="https://www.youtube.com/user/AImexico" target="_blank" rel="noopener noreferrer">
                        <div className="youtube"><div className="imagen-youtube"></div></div>
                    </a>
                </div>
                <div className="footer-inferior-der">

                </div>
            </div>
        </div>
    )
}
